export default __webpack_public_path__ + "images/onboarding/splashverse-onboarding-ela-v2-1ec537766d8e0c4742385d58da42fe3b.png";